import { render, staticRenderFns } from "./positionNav.vue?vue&type=template&id=c0fe701a&scoped=true&"
import script from "./positionNav.vue?vue&type=script&lang=js&"
export * from "./positionNav.vue?vue&type=script&lang=js&"
import style0 from "./positionNav.vue?vue&type=style&index=0&id=c0fe701a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fe701a",
  null
  
)

export default component.exports